var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications"},[_c('transition-group',{attrs:{"name":_vm.transitionName,"mode":_vm.transitionMode}},_vm._l((_vm.notifications),function(notification){return _c('notification',_vm._b({key:notification.timestamp.getTime(),attrs:{"clickHandler":notification.onClick},on:{"close":_vm.removeNotification}},'notification',notification,false))}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b63049e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/components/NotificationPlugin/Notifications.vue
// module id = 424
// module chunks = 3